import { text } from "stream/consumers";
import { itx } from "../../translationItx/itx";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  return [
    {
      id: () => {
        return `tv-${state.cabinets.id}`;
      },
      action: enumActions.focus,
    },
    {
      id: () => {
        return [`tv-${state.cabinets.id}`, "ContextMenuLables_addCabinet"]; // no itx
      },
      action: enumActions.click,
    },
    {
      action: enumActions.call,
      subSequence: () => {
        if (state.cabinets.size == 0) {
          return [
            {
              id: `CabinetDialog_tag`,
              action: enumActions.explain,
              text: itx("onBoardingSequences.defaultNewCabinet"),
            },
          ];
        } else {
          // calc here the name and tag
          let choosenName = "Schaltschrank 1"; // no itx
          let allPossibleName = [
            itx("components.Cabinet") + " " + itx("step1.groundFloor", "Erdgeschoss"),
            itx("components.Cabinet") + " " + itx("step1.attic", "Dachgeschoss"),
            itx("components.Cabinet") + " " + itx("step1.cellar", "Keller"),
            itx("components.Cabinet") + " " + itx("step1.loft", "Bühne"),
            itx("components.Cabinet") + " " + itx("step1.floorX", "Etage x"),
          ];
          allPossibleName.forEach((possibility) => {
            let allreadyInProject = false;
            state.cabinets.forEach((cabinet) => {
              if (cabinet.name == possibility) {
                allreadyInProject = true;
              }
            });
            if (!allreadyInProject && choosenName == "Schaltschrank 1") {
              choosenName = possibility;
            }
          });
          return [
            // {
            //   id: `CabinetDialog_name`,
            //   action: enumActions.explain,
            //   text: itx("onBoardingSequences.cabinetGiveNameTag"),
            // },
            {
              id: `CabinetDialog_name`,
              action: enumActions.type,
              text: choosenName,
            },
          ];
        }
      },
    },
    {
      id: `BaseDialog_ok`,
      action: enumActions.click,
    },
    // {
    //   action: enumActions.explain,
    //   text: itx("onBoardingSequences.cabinetCreated"),
    // },
  ];
}

export default sequence;
